<template>
    <b-card no-body>
        
            <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
                <brut-create-or-update v-model="brut" :errors="errors"></brut-create-or-update>
                <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
            </b-modal>
        
            <v-table    ref="table"
                        :buttons="buttons"
                        :fields="fields"
                        name="brut-operations"
                        pagination="server"
                        :items-provider="provider"
                        :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import BrutCreateOrUpdate from './components/BrutCreateOrUpdate.vue';
import HumanResourcesParameterApi from '@/api/human-resources-parameters';
export default {
    components:{
        BCard,
        BrutCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {key:"StartDateStr",name:"Başlangıç Tarihi"},   
                {key:"EndDateStr",name:"Bitiş Tarihi"},   
                {key:"KGVM_1_Deger",name:"KGVM_1_Deger"},   
                {key:"KGVM_2_Deger",name:"KGVM_2_Deger"},   
                {key:"KGVM_3_Deger",name:"KGVM_3_Deger"},   
                {key:"KGVM_4_Deger",name:"KGVM_4_Deger"},   
                {key:"KGVM_5_Deger",name:"KGVM_5_Deger"},   
                {key:"KGVM_1_Oran",name:"KGVM_1_Oran"},   
                {key:"KGVM_2_Oran",name:"KGVM_2_Oran"},   
                {key:"KGVM_3_Oran",name:"KGVM_3_Oran"},   
                {key:"KGVM_4_Oran",name:"KGVM_4_Oran"},   
                {key:"KGVM_5_Oran",name:"KGVM_5_Oran"},   
                {key:"SGKIsciOran",name:"SGK İşçi Oran"},   
                {key:"SGKIsciKontrolDegeri",name:"SGK İşçi Kontrol Değeri",sortable:true},   
                {key:"IssizlikIsciOran",name:"İşsizlik İşçi Oran"},   
                {key:"IssizlikIsciKontrolDegeri",name:"İşsizlik İşci Kontrol Değeri",sortable:true},   
                {key:"GVIstisnasi",name:"GV Istisnasi"},   
                {key:"DamgaVergisiDegeri",name:"Damga Vergisi Değeri"},   
                {key:"DamgaVergisiOrani",name:"Damga Vergisi Oranı"},   
                {key:"SGKIsverenDeger",name:"SGK İşveren Değer"},   
                {key:"SGKIsverenOran",name:"SGK İşveren Oran"},   
                {key:"IsverenIssizlikDeger",name:"İşveren İşsizlik Değer",sortable:true},   
                {key:"IsverenIsslizlikOran",name:"İşveren İşsizlik Oran"},   
                
            ],
            buttons:[
                { text:"Netten Brüt Hesapla",key:"calculate",icon:"TargetIcon",variant:"primary",action:this.calculate },
            ],
            editing:false,
            errors:{},
            loading:false,
            brut:{
                Id:null,
                KGVM_1_Deger:null,
                KGVM_2_Deger:null,
                KGVM_3_Deger:null,
                KGVM_4_Deger:null,
                KGVM_5_Deger:null,
                KGVM_1_Oran:null,
                KGVM_2_Oran:null,
                KGVM_3_Oran:null,
                KGVM_4_Oran:null,
                KGVM_5_Oran:null,
                SGKIsciOran:null,
                SGKIsciKontrolDegeri:null,
                IssizlikIsciOran:null,
                IssizlikIsciKontrolDegeri:null,
                GVIstisnasi:null,
                DamgaVergisiDegeri:null,
                DamgaVergisiOrani:null,
                SGKIsverenDeger:null,
                SGKIsverenOran:null,
                IsverenIssizlikDeger:null,
                IsverenIsslizlikOran:null,
                StartDate:null
            }
        }
    },
    methods:{
        calculate(item){
            let net = 15000
            HumanResourcesParameterApi.Brut.Calculate(net,item.Id).then(res=>{
                console.log(res.data)
            }).catch(err=>{
            })
        },
        clearForm(){
            this.editing = false
               this.brut.Id=null
               this.brut.KGVM_1_Deger=null
               this.brut.KGVM_2_Deger=null
               this.brut.KGVM_3_Deger=null
               this.brut.KGVM_4_Deger=null
               this.brut.KGVM_5_Deger=null
               this.brut.KGVM_1_Oran=null
               this.brut.KGVM_2_Oran=null
               this.brut.KGVM_3_Oran=null
               this.brut.KGVM_4_Oran=null
               this.brut.KGVM_5_Oran=null
               this.brut.SGKIsciOran=null
               this.brut.SGKIsciKontrolDegeri=null
               this.brut.IssizlikIsciOran=null
               this.brut.IssizlikIsciKontrolDegeri=null
               this.brut.GVIstisnasi=null
               this.brut.DamgaVergisiDegeri=null
               this.brut.DamgaVergisiOrani=null
               this.brut.SGKIsverenDeger=null
               this.brut.SGKIsverenOran=null
               this.brut.IsverenIssizlikDeger=null
               this.brut.IsverenIsslizlikOran=null
               this.brut.StartDate=null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return HumanResourcesParameterApi.Brut.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.brut.Id=null
            this.brut.KGVM_1_Deger=item.KGVM_1_Deger
            this.brut.KGVM_2_Deger=item.KGVM_2_Deger
            this.brut.KGVM_3_Deger=item.KGVM_3_Deger
            this.brut.KGVM_4_Deger=item.KGVM_4_Deger
            this.brut.KGVM_5_Deger=item.KGVM_5_Deger
            this.brut.KGVM_1_Oran=item.KGVM_1_Oran
            this.brut.KGVM_2_Oran=item.KGVM_2_Oran
            this.brut.KGVM_3_Oran=item.KGVM_3_Oran
            this.brut.KGVM_4_Oran=item.KGVM_4_Oran
            this.brut.KGVM_5_Oran=item.KGVM_5_Oran
            this.brut.SGKIsciOran=item.SGKIsciOran
            this.brut.SGKIsciKontrolDegeri=item.SGKIsciKontrolDegeri
            this.brut.IssizlikIsciOran=item.IssizlikIsciOran
            this.brut.IssizlikIsciKontrolDegeri=item.IssizlikIsciKontrolDegeri
            this.brut.GVIstisnasi=item.GVIstisnasi
            this.brut.DamgaVergisiDegeri=item.DamgaVergisiDegeri
            this.brut.DamgaVergisiOrani=item.DamgaVergisiOrani
            this.brut.SGKIsverenDeger=item.SGKIsverenDeger
            this.brut.SGKIsverenOran=item.SGKIsverenOran
            this.brut.IsverenIssizlikDeger=item.IsverenIssizlikDeger
            this.brut.IsverenIsslizlikOran=item.IsverenIsslizlikOran
            this.brut.StartDate=item.StartDate
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            HumanResourcesParameterApi.Brut.CreateOrUpdate(this.editing,this.brut).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
    
    }
}
</script>

<style>

</style>